import {createContext} from 'react';
import {Observable} from 'rxjs';
import {ElementStatus} from '../types';

export type FormElementContextState<T = any> = {
	readonly value: T;
	setValue: (value: T) => void;
	setStatus: (value: ElementStatus) => void;
	validate: (silence?: boolean) => Observable<string[]>;
	status: ElementStatus;
	hasError: (errorType: string) => boolean;
	firstError: () => string;
	setRef: (ref: HTMLElement | HTMLInputElement | HTMLSelectElement | any) => void;
	ref: HTMLElement | HTMLInputElement | HTMLSelectElement | any;
	validateOnBlur: () => void;
};

export const FormElementContext = createContext<FormElementContextState>(null);
FormElementContext.displayName = 'FormElementContext';
export default FormElementContext;
